import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import CookieBanner from "./CookieBanner";
import { Toaster } from "sonner";

export default function Layout({ children }) {
  return (
    <div className="min-h-screen bg-[#F5EFE4] text-[#1A1815]">
      <Header />
      <main>{children}</main>
      <Footer />
      <CookieBanner />
      <Toaster theme="light" position="bottom-right"
        toastOptions={{ style: { background: "#1A1815", color: "#F5EFE4", border: "1px solid #C5A059", borderRadius: 2 } }} />
    </div>
  );
}
